import { createSlice } from "@reduxjs/toolkit";

/**
 *
 * @type SmartProposalStoreState
 */
const initialState = {
  smartProposalList: { loading: false, data: null, error: null },
  createSmartProposal: { loading: false, data: null, error: null },
  updateSmartProposal: { loading: false, data: null, error: null },
  archiveSmartProposal: { loading: false, data: null, error: null },
  sendDraftProposal: { loading: false, data: null, error: null },
  deleteSmartProposal: { loading: false, data: null, error: null },
  bookMarkSmartProposal: { loading: false, data: null, error: null },
  proposalActivityList: { loading: false, data: null, error: null },
  addNotesForProposal: { loading: false, data: null, error: null },
  updateDetailProposal: { loading: false, data: null, error: null },
  getContactlist: { loading: false, data: null, error: null },
  getContactlist1: { loading: false, data: null, error: null },
  smartProposalReport: { loading: false, data: null, error: null },
  uploadAttachementForProposal: { loading: false, data: null, error: null },
  getPublicLink: { loading: false, data: null, error: null },
  removeDocument: { loading: false, data: null, error: null },
  downloadProposal: { loading: false, data: null, error: null },

  createAgreementFromProposal: { loading: false, data: null, error: null },
};

export const SmartProposalSlice = createSlice({
  name: "smartProposal",
  initialState,
  reducers: {
    fetchSmartProposalListRequest: (state, action) => {
      state.smartProposalList.loading = true;
      state.smartProposalList.error = null;
    },
    fetchSmartProposalListSuccess: (state, action) => {
      state.smartProposalList.data = action.payload;
      state.smartProposalList.loading = false;
      state.smartProposalList.error = null;
    },
    fetchSmartProposalListFailure: (state, action) => {
      state.smartProposalList.data = null;
      state.smartProposalList.loading = false;
      state.smartProposalList.error = action.payload;
    },
    fetchAllSmartProposalListRequest: (state, action) => {
      state.smartProposalList.loading = false;
      state.smartProposalList.error = null;
    },
    fetchAllSmartProposalListSuccess: (state, action) => {
      state.smartProposalList.data = action.payload;
      state.smartProposalList.loading = false;
      state.smartProposalList.error = null;
    },
    fetchAllSmartProposalListFailure: (state, action) => {
      state.smartProposalList.data = null;
      state.smartProposalList.loading = false;
      state.smartProposalList.error = action.payload;
    },
    createSmartProposalRequest: (state, action) => {
      state.createSmartProposal.loading = true;
      state.createSmartProposal.error = null;
    },
    createSmartProposalSuccess: (state, action) => {
      state.createSmartProposal.data = action.payload;
      state.createSmartProposal.loading = false;
      state.createSmartProposal.error = null;
    },
    createSmartProposalFailure: (state, action) => {
      state.createSmartProposal.data = null;
      state.createSmartProposal.loading = false;
      state.createSmartProposal.error = action.payload||"error";
    },
    updateSmartProposalRequest: (state, action) => {
      state.updateSmartProposal.loading = true;
      state.updateSmartProposal.error = null;
    },
    updateSmartProposalSuccess: (state, action) => {
      state.updateSmartProposal.data = action.payload;
      state.updateSmartProposal.loading = false;
      state.updateSmartProposal.error = null;
    },
    updateSmartProposalFailure: (state, action) => {
      state.updateSmartProposal.data = null;
      state.updateSmartProposal.loading = false;
      state.updateSmartProposal.error = action.payload;
    },
    archiveSmartProposalRequest: (state, action) => {
      state.archiveSmartProposal.loading = true;
      state.archiveSmartProposal.error = null;
    },
    archiveSmartProposalSuccess: (state, action) => {
      state.archiveSmartProposal.data = action.payload;
      state.archiveSmartProposal.loading = false;
      state.archiveSmartProposal.error = null;
    },
    archiveSmartProposalFailure: (state, action) => {
      state.archiveSmartProposal.data = null;
      state.archiveSmartProposal.loading = false;
      state.archiveSmartProposal.error = action.payload;
    },
    deleteSmartProposalRequest: (state, action) => {
      state.deleteSmartProposal.loading = true;
      state.deleteSmartProposal.error = null;
    },
    deleteSmartProposalSuccess: (state, action) => {
      state.deleteSmartProposal.data = action.payload;
      state.deleteSmartProposal.loading = false;
      state.deleteSmartProposal.error = null;
    },
    deleteSmartProposalFailure: (state, action) => {
      state.deleteSmartProposal.data = null;
      state.deleteSmartProposal.loading = false;
      state.deleteSmartProposal.error = action.payload;
    },
    bookmarkSmartProposalRequest: (state, action) => {
      state.bookMarkSmartProposal.loading = true;
      state.bookMarkSmartProposal.error = null;
    },
    bookmarkSmartProposalSuccess: (state, action) => {
      state.bookMarkSmartProposal.data = action.payload;
      state.bookMarkSmartProposal.loading = false;
      state.bookMarkSmartProposal.error = null;
    },
    bookmarkSmartProposalFailure: (state, action) => {
      state.bookMarkSmartProposal.data = null;
      state.bookMarkSmartProposal.loading = false;
      state.bookMarkSmartProposal.error = action.payload;
    },
    fetchProposalActivityListRequest: (state, action) => {
      state.proposalActivityList.loading = true;
      state.proposalActivityList.error = null;
    },
    fetchProposalActivityListSuccess: (state, action) => {
      state.proposalActivityList.data = action.payload;
      state.proposalActivityList.loading = false;
      state.proposalActivityList.error = null;
    },
    fetchProposalActivityListFailure: (state, action) => {
      state.proposalActivityList.data = null;
      state.proposalActivityList.loading = false;
      state.proposalActivityList.error = action.payload;
    },
    //sendDraft Proposal
    createSendDraftProposalRequest: (state, action) => {
      state.sendDraftProposal.loading = true;
      state.sendDraftProposal.error = null;
    },
    createSendDraftProposalSuccess: (state, action) => {
      state.sendDraftProposal.data = action.payload;
      state.sendDraftProposal.loading = false;
      state.sendDraftProposal.error = null;
    },
    createSendDraftProposalFailure: (state, action) => {
      state.sendDraftProposal.data = action.payload;
      state.sendDraftProposal.loading = false;
      state.sendDraftProposal.error = action.payload;
    },
    addNotesForProposalRequest: (state, action) => {
      state.addNotesForProposal.loading = true;
      state.addNotesForProposal.error = null;
    },
    addNotesForProposalSuccess: (state, action) => {
      state.addNotesForProposal.data = action.payload;
      state.addNotesForProposal.loading = false;
      state.addNotesForProposal.error = null;
      state.proposalActivityList.error = action.payload;
    },
    addNotesForProposalFailure: (state, action) => {
      state.addNotesForProposal.data = null;
      state.addNotesForProposal.loading = false;
      state.addNotesForProposal.error = action.payload;
    },
    updateDetailProposalRequest: (state, action) => {
      state.updateDetailProposal.loading = true;
      state.updateDetailProposal.error = null;
    },
    updateDetailProposalSuccess: (state, action) => {
      state.updateDetailProposal.data = action.payload;
      state.updateDetailProposal.loading = false;
      state.updateDetailProposal.error = null;
    },
    updateDetailProposalFailure: (state, action) => {
      state.updateDetailProposal.data = null;
      state.updateDetailProposal.loading = false;
      state.updateDetailProposal.error = action.payload;
    },
    getContactlistRequest: (state, action) => {
      state.getContactlist.loading = true;
      state.getContactlist.error = null;
    },
    getContactlistRequest1: (state, action) => {
      state.getContactlist1.loading = true;
      state.getContactlist1.error = null;
    },

    getContactlistSuccess: (state, action) => {
      state.getContactlist.data = action.payload;
      state.getContactlist.loading = false;
      state.getContactlist.error = null;
      state.getContactlist.error = action.payload;
    },
    getContactlistSuccess1: (state, action) => {
      state.getContactlist1.data = action.payload;
      state.getContactlist1.loading = false;
      state.getContactlist1.error = null;
      state.getContactlist1.error = action.payload;
    },

    getContactlistFailure: (state, action) => {
      state.getContactlist.data = null;
      state.getContactlist.loading = false;
      state.getContactlist.error = action.payload;
    },
    getContactlistFailure1: (state, action) => {
      state.getContactlist1.data = null;
      state.getContactlist1.loading = false;
      state.getContactlist1.error = action.payload;
    },
    fetchSmartProposalReportRequest: (state, action) => {
      state.smartProposalReport.loading = true;
      state.smartProposalReport.error = null;
    },
    fetchSmartProposalReportSuccess: (state, action) => {
      state.smartProposalReport.data = action.payload;
      state.smartProposalReport.loading = false;
      state.smartProposalReport.error = null;
    },
    fetchSmartProposalReportFailure: (state, action) => {
      state.smartProposalReport.data = null;
      state.smartProposalReport.loading = false;
      state.smartProposalReport.error = action.payload;
    },
    // reset create proposal
    resetCreateProposalState: (state, action) => {
      state.createSmartProposal = initialState.createSmartProposal;
    },
    // reset Update proposal
    resetUpdateProposalState: (state, action) => {
      state.updateSmartProposal = initialState.updateSmartProposal;
    },
    // reset draft proposal
    resetDraftProposalState: (state, action) => {
      state.sendDraftProposal = initialState.sendDraftProposal;
    },
    // archive proposal
    resetArchiveProposalState: (state, action) => {
      state.archiveSmartProposal = initialState.archiveSmartProposal;
    },
    // bookmark proposal
    resetBookMarkProposalState: (state, action) => {
      state.bookMarkSmartProposal = initialState.bookMarkSmartProposal;
    },
    // uploadAttachementForProposal proposal
    resetuploadAttachementProposalState: (state, action) => {
      state.uploadAttachementForProposal =
        initialState.uploadAttachementForProposal;
    },

    // removeDocument proposal
    resetremoveDocumentProposalState: (state, action) => {
      state.removeDocument = initialState.removeDocument;
    },
    //
    //upload document
    uploadDocumentForProposalRequest: (state, action) => {
      state.uploadAttachementForProposal.loading = true;
      state.uploadAttachementForProposal.error = null;
    },

    uploadDocumentForProposalSuccess: (state, action) => {
      state.uploadAttachementForProposal.data = action.payload;
      state.uploadAttachementForProposal.loading = false;
      state.uploadAttachementForProposal.error = null;
    },
    uploadDocumentForProposalFailure: (state, action) => {
      state.uploadAttachementForProposal.data = null;
      state.uploadAttachementForProposal.loading = false;
      state.uploadAttachementForProposal.error = action.payload;
    },
    //for public link
    publicLinkForProposalRequest: (state, action) => {
      state.getPublicLink.loading = true;
      state.getPublicLink.error = null;
    },
    publicLinkForProposalSuccess: (state, action) => {
      state.getPublicLink.data = action.payload;
      state.getPublicLink.loading = false;
      state.getPublicLink.error = null;
    },
    publicLinkForProposalFailure: (state, action) => {
      state.getPublicLink.data = null;
      state.getPublicLink.loading = false;
      state.getPublicLink.error = action.payload;
    },
    //remove document
    removeDocumentForProposalRequest: (state, action) => {
      state.uploadAttachementForProposal.loading = true;
      state.uploadAttachementForProposal.error = null;
    },

    removeDocumentForProposalSuccess: (state, action) => {
      state.uploadAttachementForProposal.data = action.payload;
      state.uploadAttachementForProposal.loading = false;
      state.uploadAttachementForProposal.error = null;
    },
    removeDocumentForProposalFailure: (state, action) => {
      state.uploadAttachementForProposal.data = null;
      state.uploadAttachementForProposal.loading = false;
      state.uploadAttachementForProposal.error = action.payload;
    },
    // Download proposal
    downloadProposalRequest: (state, action) => {
      state.downloadProposal.loading = true;
      state.downloadProposal.error = null;
    },

    downloadProposalSuccess: (state, action) => {
      state.downloadProposal.data = action.payload;
      state.downloadProposal.loading = false;
      state.downloadProposal.error = null;
    },
    downloadProposalFailure: (state, action) => {
      state.downloadProposal.data = null;
      state.downloadProposal.loading = false;
      state.downloadProposal.error = action.payload;
    },

    // reset download subscribe
    resetDownloadProposalState: (state, action) => {
      state.downloadProposal = initialState.downloadProposal;
    },

    createAgreementFromProposalRequest: (state, action) => {
      state.createAgreementFromProposal.loading = true;
      state.createAgreementFromProposal.error = null;
    },
    createAgreementFromProposalSuccess: (state, action) => {
      state.createAgreementFromProposal.data = action.payload;
      state.createAgreementFromProposal.loading = false;
      state.createAgreementFromProposal.error = null;
    },
    createAgreementFromProposalFailure: (state, action) => {
      state.createAgreementFromProposal.data = null;
      state.createAgreementFromProposal.loading = false;
      state.createAgreementFromProposal.error = action.payload;
    },
  },
});

/**
 *
 * @param {SmartProposalForm} dataToUpdate
 * @param {SmartProposalListStoreState} state
 * @returns {SmartProposalListStoreState}
 */
function addNewSmartProposal(dataToUpdate, state) {
  state.data.data = [...state.data.data, dataToUpdate];
  state.data.total++;
  return state;
}
function SendDraftProposal(dataToUpdate, state) {
  state.data.data = [...state.data.data, dataToUpdate];
  state.data.total++;
  return state;
}
export const {
  fetchSmartProposalListRequest,
  fetchSmartProposalListSuccess,
  fetchSmartProposalListFailure,
  fetchAllSmartProposalListRequest,
  fetchAllSmartProposalListSuccess,
  fetchAllSmartProposalListFailure,
  createSmartProposalFailure,
  createSmartProposalRequest,
  createSmartProposalSuccess,
  updateSmartProposalRequest,
  updateSmartProposalFailure,
  updateSmartProposalSuccess,
  archiveSmartProposalRequest,
  archiveSmartProposalFailure,
  archiveSmartProposalSuccess,
  deleteSmartProposalRequest,
  deleteSmartProposalSuccess,
  deleteSmartProposalFailure,
  bookmarkSmartProposalRequest,
  bookmarkSmartProposalSuccess,
  bookmarkSmartProposalFailure,
  createSendDraftProposalRequest,
  createSendDraftProposalSuccess,
  createSendDraftProposalFailure,
  fetchProposalActivityListRequest,
  fetchProposalActivityListSuccess,
  fetchProposalActivityListFailure,
  addNotesForProposalRequest,
  addNotesForProposalSuccess,
  addNotesForProposalFailure,
  updateDetailProposalRequest,
  updateDetailProposalSuccess,
  updateDetailProposalFailure,
  getContactlistRequest,
  getContactlistFailure,
  getContactlistSuccess,

  getContactlistRequest1,
  getContactlistFailure1,
  getContactlistSuccess1,
  fetchSmartProposalReportRequest,
  fetchSmartProposalReportSuccess,
  fetchSmartProposalReportFailure,
  resetCreateProposalState,
  resetUpdateProposalState,
  resetDraftProposalState,
  uploadDocumentForProposalRequest,
  uploadDocumentForProposalSuccess,
  uploadDocumentForProposalFailure,
  publicLinkForProposalRequest,
  publicLinkForProposalFailure,
  publicLinkForProposalSuccess,
  removeDocumentForProposalRequest,
  removeDocumentForProposalSuccess,
  removeDocumentForProposalFailure,
  resetArchiveProposalState,
  resetBookMarkProposalState,
  resetuploadAttachementProposalState,
  resetremoveDocumentProposalState,
  downloadProposalRequest,
  downloadProposalSuccess,
  downloadProposalFailure,
  resetDownloadProposalState,
  downloadProposalRequestType,
} = SmartProposalSlice.actions;

/**
 *
 * @param {*} state
 * @returns {SmartProposalStoreState}
 */
export const getSmartProposalListState = (state) => {
  return state?.smartProposal;
};

export const getSendDraftProposalState = (state)=>{
   return state?.sendDraftProposal
}

export const getSmartProposalListState1 = (state) => {
  return state?.smartProposal?.getContactlist1;
};

export const createSmartProposalState = (state) => {
  return state?.smartProposal?.createSmartProposal;
};
export const getSmartProposalReportState = (state) => {
  return state?.smartProposal?.smartProposalReport;
};

export const getPublicUrlState = (state) => {
  return state?.smartProposal?.getPublicLink;
};
export const getDownloadProposal = (state) => {
  return state?.smartProposal?.downloadProposal;
};

export const getCreateAgreementFromProposalState = (state) => {
  return state?.smartProposal?.createAgreementFromProposal;
};

export default SmartProposalSlice.reducer;
